module.exports = __webpack_public_path__ + "img/check_white.778f1c72.svg";